import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ENLanguage from './en.json';
import KRLanguage from './kr.json';
import VILanguage from './vi.json';
import JPLanguage from './jp.json';

const resources = {
  en: {
    translation: ENLanguage,
  },
  jp: {
    translation: JPLanguage,
  },
  kr: {
    translation: KRLanguage,
  },
  vie: {
    translation: VILanguage,
  },
};
const lgnDefault = window.localStorage.getItem('language');

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: lgnDefault ?? 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
